import { ref, computed, onMounted, onUnmounted } from "vue";

import { useToast } from "@/components/paintpro/composables/useToast";
import { useConfirm } from "@/components/paintpro/composables/useConfirm";
import { useAlert } from "@/components/paintpro/composables/useAlert";
import { useLoading } from "@/components/paintpro/composables/useLoading";
import { useBaseCmDialog } from "@/components/paintpro/composables/useBaseCmDialog";
import { useBaseOrderDialog } from "@/components/paintpro/composables/useBaseOrderDialog";
import { useBaseProdDialog } from "@/components/paintpro/composables/useBaseProdDialog";
import { useBaseDispDialog } from "@/components/paintpro/composables/useBaseDispDialog";
// import * as cmApi from "@/api/cmApi";
import * as store from "@/store";

// 브레이크포인트 설정
const BREAKPOINTS = {
  MOBILE: 768,
  TABLET: 1024,
};

export function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substring(1).match(reg);
  if (r != null) {
    return r[2];
  } else {
    return null;
  }
}

/**************************
 * 스토어 초기화
 **************************/
export async function resetToken() {
  removeLocalStorage("token");
  removeLocalStorage("token_refreshToken");
  removeLocalStorage("token_refreshYn");
  //removeLocalStorage("_token_time");
  //removeLocalStorage("_token_refreshTime");
  //removeLocalStorage("_token_createDate");
}

export async function resetStore() {
  resetToken();
  //removeLocalStorage("gv.commonPop.hiddenDate");
  //removeLocalStorage("gv.loginTime");
  //removeLocalStorage("gv.accessToken");
  //removeLocalStorage("gv.refreshToken");
  //removeLocalStorage("gv.loginInfo");
  removeLocalStorage("gv.system");
  removeLocalStorage("gv.basketCount");
  removeLocalStorage("gv.alimCount");
  //removeLocalStorage("gv.pageLoadTime");
  removeLocalStorage("gv.systemNoticeYn");

  //removeLocalStorage("gv.returnUrl");

  store.useAuthStore().setLoginUser({});
  store.useAuthStore().setReturnUrl("");
  store.useBasketCountStore().setBasketCount(0);
  store.useAlimCountStore().setAlimCount(0);
  store.useEventBusStore().setSalesPersonIndex(0);
  store.useEventBusStore().setIsCookiePop(false);
  store.useEventBusStore().setIsCommonPop(false);
  store.useEventBusStore().setSystemNoticeYn("");
  //store.useEventBusStore().setReturnUrl("");
}

/**************************
 * 로컬 스토리지지
 **************************/
export const getLocalStorage = (name) => {
  return localStorage.getItem(name);
};

export const setLocalStorage = (name, value) => {
  localStorage.setItem(name, value);
};

export const removeLocalStorage = (key) => {
  localStorage.removeItem(key);
};

/**************************
 * 디바이스 체크
 **************************/
// export const isMobile = () => {

export const useDeviceType = () => {
  // 화면 너비를 reactive로 관리
  const windowWidth = ref(window.innerWidth);

  // deviceType을 computed로 관리
  const deviceType = computed(() => {
    if (windowWidth.value <= BREAKPOINTS.MOBILE) return "MOBILE";
    if (windowWidth.value <= BREAKPOINTS.TABLET) return "TABLET";
    return "DESKTOP";
  });

  // 디바이스 타입별 상태를 computed로 관리
  const isMobile = computed(() => deviceType.value === "MOBILE");
  const isTablet = computed(() => deviceType.value === "TABLET");
  const isDesktop = computed(() => deviceType.value === "DESKTOP");

  // resize 이벤트에 대한 디바운스 처리
  let timeoutId = null;
  const handleResize = () => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      windowWidth.value = window.innerWidth;
    }, 50);
  };

  // 컴포넌트 마운트/언마운트 시 이벤트 처리
  onMounted(() => {
    window.addEventListener("resize", handleResize);
  });

  onUnmounted(() => {
    window.removeEventListener("resize", handleResize);
    clearTimeout(timeoutId);
  });

  return {
    deviceType,
    isMobile,
    isTablet,
    isDesktop,
  };
};

/**************************
 * 토스트 다이얼로그 출력
 **************************/
export const toast = (msg, opts = {}) => {
  useToast().showToast(msg, opts);
};

// 닫기기
export const toastHide = () => {
  return useToast().hideToast();
};

/**************************
 * 컨펀 다이얼로그 출력
 **************************/
export const confirm = async (msg, opts = {}) => {
  return await useConfirm().showConfirm(msg, opts);
};

// 닫기
export const confirmHide = () => {
  return useConfirm().hideConfirm();
};

/**************************
 * 얼럿 다이얼로그 출력
 **************************/
export const alert = async (msg, opts = {}) => {
  return await useAlert().showAlert(msg, opts);
};

// 닫기
export const alertHide = () => {
  return useAlert().hideAlert();
};

/**************************
 * 로딩 다이얼로그 출력
 **************************/
export const loading = (msg, opts = {}) => {
  return useLoading().showLoading(msg, opts);
};

// 닫기
export const loadingHide = () => {
  return useLoading().hideLoading();
};

/**************************
 * 기본 CM 다이얼로그
 **************************/
export const baseCmDialog = async (msg, opts = {}) => {
  return await useBaseCmDialog().showBaseCmDialog(msg, opts);
};

/**************************
 * 기본 Order 다이얼로그
 **************************/
export const baseOrderDialog = async (msg, opts = {}) => {
  return await useBaseOrderDialog().showBaseOrderDialog(msg, opts);
};

/**************************
 * 기본 Prod 다이얼로그
 **************************/
export const baseProdDialog = async (msg, opts = {}) => {
  return await useBaseProdDialog().showBaseProdDialog(msg, opts);
};

/**************************
 * 기본 Disp 다이얼로그
 **************************/
export const baseDispDialog = async (msg, opts = {}) => {
  return await useBaseDispDialog().showBaseDispDialog(msg, opts);
};

/**************************
 * 공통 팝업 클래스 제거거
 **************************/
export const removeClassPopupOpen = () => {
  removeClass("popup-open");
};

export const removeClass = (className) => {
  document.documentElement.classList.remove(className);
};

/**************************
 * 오늘날짜 가져오기
 **************************/
export const getToday = (format = "yyyyMMdd") => {
  const today = new Date();
  const year = today.getFullYear();
  const month = (today.getMonth() + 1).toString().padStart(2, "0"); // 0부터 시작하므로 +1 필요
  const day = today.getDate().toString().padStart(2, "0");
  const hours = today.getHours().toString().padStart(2, "0");
  const minutes = today.getMinutes().toString().padStart(2, "0");
  const seconds = today.getSeconds().toString().padStart(2, "0");
  let dt = "";
  if (format === "yyyy-MM-dd") {
    dt = `${year}-${month}-${day}`;
  } else if (format === "yyyy/MM/dd") {
    dt = `${year}/${month}/${day}`;
  } else if (format === "yyyyMMdd") {
    dt = `${year}${month}${day}`;
  } else if (format === "yyyyMMddHHmmss") {
    dt = `${year}${month}${day}${hours}${minutes}${seconds}`;
  } else if (format === "yyyyMMdd HHmmss") {
    dt = `${year}${month}${day} ${hours}${minutes}${seconds}`;
  } else if (format === "yyyy-MM-dd HH:mm:ss") {
    dt = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  } else if (format === "HH:mm:ss") {
    dt = `${hours}:${minutes}:${seconds}`;
  }
  return dt;
};

/**************************
 * 사용자 개인화 정보 설정정
 **************************/
export const setUserPersonInfo = () => {
  const empId = store.useAuthStore().user?.personInfo?.chcZempNo || "";
  const empList = store.useAuthStore().user?.empList || [];
  if (empId && empList.length > 0) {
    for (let i = 0; i < empList.length; i++) {
      let itm = empList[i];
      if (itm.kunn2 === empId) {
        store.useEventBusStore().setSalesPersonIndex(i);
        break;
      }
    }
  }
};

/**************************
 * 시스템공지 체크
 **************************/
export const checkSystemNotice = () => {
  if (
    store.useEventBusStore().systemNoticeYn === "Y" ||
    getLocalStorage("gv.systemNoticeYn") === "Y"
  ) {
    //loading("시스템공지 이동합니다.");
    location.href = "/paintpro/error/systemCheck";
    return false;
  }
};

/**
 * 경로 패턴이 주어진 경로와 일치하는지 확인합니다.
 * 패턴은 '*' 와일드카드를 사용할 수 있습니다.
 * 특수 문자를 이스케이프하되 '*'는 정규식 와일드카드로 변환 
isPathLike('/api/*', '/api/users'); // true
isPathLike('/api/*', '/app/users'); // false
isPathLike('*.js', 'script.js'); // true
 */
export const isPathLike = (pattern, path) => {
  const regexPattern = pattern
    .replace(/[.+?^${}()|[\]\\]/g, "\\$&") // 특수 문자 이스케이프
    .replace(/\*/g, ".*"); // '*'를 정규식 와일드카드로 변환
  const regex = new RegExp(`^${regexPattern}$`); // 시작과 끝 경계 추가
  return regex.test(path); // 패턴과 경로 비교
};

/**
 * 500 오류여부 체크
 */
export const checkApiError = (response, resultCode, message) => {
  if (resultCode === 500) {
    //loading("오류페이지로 이동합니다.");
    location.href =
      "/paintpro/error/error500?status=" +
      (status || "") +
      "&resultCode=" +
      (resultCode || "") +
      "&message=" +
      (message || "") +
      "&pagePath=" +
      location.pathname;
    return false;
  } else {
    return true;
  }
};

/**
 * script 태그와 이벤트 핸들러 제거
 */
export const sanitizeHTML = (html) => {
  let sanitized = html;
  if (sanitized != null) {
    try {
      sanitized = sanitized.replace(/<script[^>]*>[\s\S]*?<\/script>/gi, "");
      sanitized = sanitized.replace(/on\w+="[^"]*"/gi, "");
      sanitized = sanitized.replace("onerror", "_onerror");
      sanitized = sanitized.replace("alert", "console.log");
      //sanitized = sanitized.replace("document.cookie", "--document.cookie");
    } catch (e) {
      console.log(e);
      console.log(html);
    }
  }
  return sanitized;
};

export const sanitizeHTML2 = (html) => {
  let sanitized = html;
  if (sanitized != null) {
    try {
      sanitized = sanitized.replace(/<script[^>]*>[\s\S]*?<\/script>/gi, "");
      sanitized = sanitized.replace(/on\w+="[^"]*"/gi, "");
      sanitized = sanitized.split("&#40;").join("(");
      sanitized = sanitized.split("&#41;").join(")");
      sanitized = sanitized.split("&#60;").join("<");
      sanitized = sanitized.split("&#61;").join("=");
      sanitized = sanitized.split("&#62;").join(">");
      sanitized = sanitized.split("+").join(" ");
      sanitized = sanitized.split("onerror").join("_onerror");
      sanitized = sanitized.split("alert").join("console.log");
      //sanitized = sanitized.replace("document.cookie", "--document.cookie");
    } catch (e) {
      console.log(e);
      console.log(html);
    }
  }
  return sanitized;
};

// 날짜비교 : 두값의 유효일자 이내인가
export const validDateDiffDay = (start, end, nDay) => {
  const startDate = new Date(start);
  const endDate = new Date(end);
  const msInOneDay = 1000 * 60 * 60 * 24;
  const timeDifference1 = endDate - startDate;
  const timeDifference2 = Math.abs(timeDifference1);
  const dayDiffCnt = timeDifference2 / msInOneDay;
  const result = dayDiffCnt <= nDay;
  return result;
};

// 날짜비교 : 두값의 차가 플러스여부
export const validDateDiffPlus = (start, end) => {
  const startDate = new Date(start);
  const endDate = new Date(end);
  const msInOneDay = 1000 * 60 * 60 * 24;
  const timeDifference1 = endDate - startDate;
  const dayDiffCnt = timeDifference1 / msInOneDay;
  const result = dayDiffCnt > -1;
  return result;
};
